module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"experience":"Experience","experience.beginner":"Without experience","experience.1-3 years":"1-3 years","experience.3-6 years":"3-6 yars","experience.6+ years":"6+ years"}}')
  delete Component.options._Ctor
}
